import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft, Plus, BookHeart, Trash2 } from "lucide-react";
import { api } from "@/lib/auth";
import { toast } from "sonner";

export default function Menus() {
  const nav = useNavigate();
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api().get("/menus");
      const data = res.data;
      setMenus(Array.isArray(data) ? data : (data?.menus || []));
    } finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const create = async () => {
    const name = prompt('Nombre del menú\n(ej: "Comida Cumpleaños Anat", "Pesaj 2026")');
    if (!name?.trim()) return;
    const res = await api().post("/menus", { name: name.trim(), recipe_slugs: [] });
    toast.success("Menú creado");
    nav(`/menu/${res.data.id}`);
  };

  const remove = async (m) => {
    if (!window.confirm(`¿Eliminar "${m.name}"?`)) return;
    await api().delete(`/menus/${m.id}`);
    setMenus((ms) => ms.filter((x) => x.id !== m.id));
  };

  return (
    <div className="min-h-screen paper-texture iphone-safe-top">
      <header className="sticky top-0 z-30 bg-paper/95 backdrop-blur-md border-b border-line">
        <div className="max-w-3xl mx-auto px-4 py-3 flex items-center justify-between">
          <Link to="/cocina" className="p-2 rounded-full bg-cream border border-line"><ChevronLeft className="w-5 h-5 text-cocoa" /></Link>
          <h1 className="font-display italic text-cocoa text-xl">Mis Menús</h1>
          <button data-testid="new-menu-btn" onClick={create} className="p-2 rounded-full bg-cream border border-line"><Plus className="w-5 h-5 text-cocoa" /></button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-5 pt-6 pb-20">
        <p className="font-serif italic text-cocoa-soft text-lg mb-6">Crea menús para fiestas, comidas o un fin de semana. La app te arma la lista de compras.</p>

        {loading && <p className="text-cocoa-soft italic">Cargando…</p>}
        {!loading && menus.length === 0 && (
          <div className="text-center py-16 bg-cream border border-line rounded-lg">
            <BookHeart className="w-12 h-12 text-amber-deep mx-auto mb-4" />
            <p className="font-serif italic text-cocoa text-lg mb-5">Todavía no tienes menús.</p>
            <button data-testid="empty-create-menu-btn" onClick={create} className="btn-primary">
              <Plus className="w-4 h-4" /> Crear mi primer menú
            </button>
          </div>
        )}

        <ul data-testid="menus-list" className="space-y-3">
          {menus.map((m) => (
            <li key={m.id} className="bg-cream border border-line rounded-lg p-4 flex items-center gap-3">
              <Link data-testid={`menu-link-${m.id}`} to={`/menu/${m.id}`} className="flex-1 min-w-0">
                <h3 className="font-display italic text-cocoa text-2xl leading-tight">{m.name}</h3>
                <p className="text-sm text-cocoa-soft font-serif">{(m.recipe_slugs || []).length} recetas</p>
              </Link>
              <button data-testid={`menu-delete-${m.id}`} onClick={() => remove(m)} className="p-2 text-cocoa-soft hover:text-amber-deep"><Trash2 className="w-4 h-4" /></button>
            </li>
          ))}
        </ul>
      </main>
    </div>
  );
}
